import styles from "./fileAttachment.module.css";
import React, { useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import deleteIcon from "../../../assets/images/delete.png"
import { getLogo } from "../../../utils/constants/fileTypeLogo";
import { Loader } from "../../../components/loader/Loader";
import IMAGES from "../../../assets/images/images";
import SecondaryTooltip from "../../secondaryToolTip/secondaryToolTip";

const FileUploadAttachment = (props) => {
    const { SetError, setFieldValue, acceptFileType, maxFileSize, combineFilesMaxSize, numOfFilesAllowToUpload, errorMessageForNumberOfFiles, maxFileSizeTXT, combineFilesMaxSizeTXT, displayMessage } = props;
    let [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        SetError(error)
    }, [error])

    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        multiple: true,
        accept: acceptFileType,
        onDrop: async (acceptedFiles) => {
            const maxSize = maxFileSize
            const combineMaxSize = combineFilesMaxSize

            if (files?.length + acceptedFiles?.length > numOfFilesAllowToUpload) {
                setError(errorMessageForNumberOfFiles);
                return;
            } else {
                setError('');
            }

            for (const file of acceptedFiles) { // checking for file size
                if (maxSize) {
                    if (file.size > maxSize) {
                        setError(`File ${file.name} exceeds ${maxFileSizeTXT} limit`);
                        return
                    } else {
                        setError('');
                    }
                }
                else {
                    setError('');
                }
            }

            let combinedSize = files?.reduce((acc, file) => acc + file.fileSize, 0);
            for (const file of acceptedFiles) {
                combinedSize += file.size;
            }
            if (combinedSize > combineMaxSize) {
                setError(combineFilesMaxSizeTXT);
                return;
            } else {
                setError("");
            }
            for (const file of acceptedFiles) {
                setUploading(true);
                let result = await props.upload({ file });
                if (result.status) {
                    let obj = {
                        originalFileName: result.res?.originalFileName,
                        uniqueFileName: result.res?.uniqueFileName,
                        fileSize: file.size
                    }
                    setFiles(files = [...files, obj]);
                    setFieldValue(props.name, files);
                    setUploading(false);
                } else {
                    setUploading(false);
                    setError(`File ${file.name} have not been uploaded correctly`);
                }
            }
        },
        onFileDialogOpen: () => {
            setError('');
        }
        , onDropRejected: (rejectedFiles) => {
            setError(`Only PDF files are supported. Please upload a document in .pdf format to continue.`);
        }
    });

    const removeFile = (file, index) => () => {
        const allFiles = [...files];
        allFiles.splice(index, 1)
        setFiles(allFiles);
        setFieldValue(props.name, allFiles);
    }
    const thumbs = files?.map((file, index) => (
        <div className={styles.thumb} key={index}>
            <div className={styles.thumbInner}>
                <div className={styles.attachment}>
                    <img className={styles.preview}
                        src={getLogo(file?.originalFileName)}
                    />
                </div>
                <div key={index} title={file?.originalFileName} className={styles.fileName}>{file.originalFileName}</div>
                <div className={styles.deleteIcon}>
                    <img
                        src={deleteIcon}
                        onClick={removeFile(file, index)}
                    />
                </div>
            </div>
        </div>
    ));

    const fileRejectionItems = fileRejections.map(({ file, errors }) => {
        return (
            <div className={styles.fileSizeError}>{file.path} {errors.map(e => e.message)}
            </div>
        )
    });


    useEffect(() => {
        if (props.value?.length == 0 || props.value === null) {
            setFiles(files = []);
            setError('')
        } else {
            setFiles(files = props.value);
        }
    }, [props.value]);

    return (
        <React.Fragment>
            <div className={styles.thumbsWrapper}>
                <div className={styles.thumbsContainer} id="thumbContainer">
                    {thumbs}
                    {/* {fileRejectionItems} */}
                </div>
                <div>
                    {uploading ? (
                        <div>
                            <Loader loaderStyle={styles.uploadLoader} />
                        </div>
                    ) : (
                        <div className={styles.uploadWrapper}>
                            {props.shoInlineError && <div>
                                {error && <div className={styles.fileSizeErrormsg}>{error}</div>}
                            </div>}

                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />
                                 <div className={styles.mainContainer}>
                                   <div>
                                     {/* <SecondaryTooltip text={displayMessage} positions={['bottom', 'right']}> */}
                                       <img className={styles.logo} src={IMAGES.iconattach} />
                                     {/* </SecondaryTooltip> */}
                                    </div>
                                 </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>         
    );
}

export default FileUploadAttachment;
